module.exports = "/static/assets/a2f27658ed6b28792e6d40e058e606e2.png";